var getters = {
  userId: function userId(state) {
    return state.app.userId;
  }
};
export default getters;